export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];
